import { useEffect } from 'react';

import { fetchTeamAccountsFallback } from 'modules/teamAccount/actions/fetchTeamAccounts';
import { useTeamAccountsQuery } from 'modules/teamAccount/actions/hooks/useTeamAccountsQuery';

import { useAccount } from './useAccount';
import { useAccountSetters } from './useAccountSetters';

export interface UseInitTeamAccountProps {
  skipFetching?: boolean;
}

export const useInitTeamAccount = ({
  skipFetching,
}: UseInitTeamAccountProps = {}) => {
  const { isPersonalAccount, isTeamAccount, isTeamAccountExist } = useAccount();

  const { setIsTeamAccountInitialized, setTeamAccountAddress } =
    useAccountSetters();

  const { loading: teamAccountsLoading, teamAccounts } = useTeamAccountsQuery({
    skipFetching: skipFetching || !isTeamAccount,
  });

  const teamAccountsLoaded =
    teamAccounts !== fetchTeamAccountsFallback && !teamAccountsLoading;

  const shouldResetTeamAccountAddress =
    isTeamAccount && teamAccountsLoaded && !isTeamAccountExist;

  useEffect(() => {
    if (isPersonalAccount) {
      setIsTeamAccountInitialized(true);
    }
  }, [isPersonalAccount, setIsTeamAccountInitialized]);

  useEffect(() => {
    if (shouldResetTeamAccountAddress) {
      setTeamAccountAddress(undefined);
    }
  }, [setTeamAccountAddress, shouldResetTeamAccountAddress]);

  useEffect(() => {
    if (isTeamAccount) {
      setIsTeamAccountInitialized(teamAccountsLoaded);
    }
  }, [teamAccountsLoaded, isTeamAccount, setIsTeamAccountInitialized]);
};
